"use client";
import { getUsersHref, getUsersName } from "@/api/users/helpers";
import { ShortUser } from "@/api/users/types";
import { NftSliderWithHeader } from "@/app/(components)/Basic/NftSliderWithHeader";
import { StaticImageData } from "next/image";
import { useRelatedArtistNfts } from "./hooks/useRelatedArtistNfts";

interface Props {
  artist: ShortUser;
  nftId: string;
  className?: string;
}

const ArtistNftSliderWithHeader = ({ artist, nftId, className }: Props) => {
  const { data: nfts } = useRelatedArtistNfts(artist.address!, nftId);

  let images: (StaticImageData & {
    link: string;
    alt: string;
    mediaType?: string;
  })[] = artist.imageUrl
    ? [
        {
          link: getUsersHref(artist),
          src: artist.imageUrl,
          width: 500,
          height: 500,
          alt: getUsersName(artist),
        },
      ]
    : [];

  if (nfts && nfts?.length > 0) {
    images = [
      ...images,
      ...nfts.map((nft) => ({
        link: `/nft/${nft.id}`,
        src: nft.thumbnail || nft.image,
        width: nft.imageWidth,
        height: nft.imageHeight,
        mediaType: nft.mediaType,
        placeholder: nft.placeholder,
        alt: nft.name,
      })),
    ];
  }

  return (
    <NftSliderWithHeader
      className={className}
      title={getUsersName(artist)}
      description={artist.description || ""}
      buttonHref={getUsersHref(artist)}
      buttonText={`View artist`}
      images={images}
    />
  );
};

export default ArtistNftSliderWithHeader;
